type Props = {
  text: string;
};

export default function Title({ text }: Props) {
  return (
    <div
      data-cy="wtb-title"
      className="text-title-sm flex items-center justify-between text-black"
    >
      {text}
    </div>
  );
}
